"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _EntelPlanCardHeader = _interopRequireDefault(require("./EntelPlanCardHeader"));
var _EntelPlanCardBody = _interopRequireDefault(require("./EntelPlanCardBody"));
var _useConfig = _interopRequireDefault(require("../../../../hooks/useConfig"));
var _recommendationSelectors = require("../../../../store/recommendation/recommendationSelectors");
var _EntelPlanDisclaimer = _interopRequireDefault(require("./EntelPlanDisclaimer"));
var _useAppSelector = require("../../../../hooks/useAppSelector");
var _services = require("../../../../services");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const EntelPlanCard = _ref => {
  let {
    plan,
    isAdditionalPlan,
    planIndex
  } = _ref;
  const additionalPlanRecommendationCharacteristics = (0, _useConfig.default)('additionalPlanRecommendationCharacteristics', []);
  const recommendationCharacteristicsConfig = (0, _useConfig.default)('recommendationCharacteristics', []);
  const recommendationCharacteristics = isAdditionalPlan || !plan ? additionalPlanRecommendationCharacteristics : recommendationCharacteristicsConfig;
  const showFullPlanName = (0, _useConfig.default)('showFullPlanName', true);
  const numPlans = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectAdditionalPlans);
  const planIdWithDifferentHeader = (0, _useConfig.default)('planIdWithDifferentHeader', []);
  const minimumDiscount = (0, _useConfig.default)('minimumDiscount', 10);
  const PlanParser = new _services.Parsers.PlanCardParser({
    recommendationCharacteristics,
    numPlans,
    plan,
    planIdWithDifferentHeader,
    isAdditionalPlan,
    showFullPlanName,
    minimumDiscount,
    planIndex
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_EntelPlanCardHeader.default, PlanParser.PlanCardHeaderProps), /*#__PURE__*/_react.default.createElement(_EntelPlanDisclaimer.default, {
    text: PlanParser.disclaimer
  }), /*#__PURE__*/_react.default.createElement(_EntelPlanCardBody.default, PlanParser.CardBodyProps));
};
var _default = EntelPlanCard;
exports.default = _default;